export default __webpack_public_path__ + "static/media/first_page_icon.3afc34a4.svg";